/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Resume_Editor_Add_WorkInputs */

const en_resume_editor_add_work = /** @type {(inputs: Resume_Editor_Add_WorkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`+ Add Work Experience`)
};

const de_resume_editor_add_work = /** @type {(inputs: Resume_Editor_Add_WorkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`+ Berufserfahrung hinzufuegen`)
};

const fr_resume_editor_add_work = /** @type {(inputs: Resume_Editor_Add_WorkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`+ Ajouter une experience`)
};

const es_resume_editor_add_work = /** @type {(inputs: Resume_Editor_Add_WorkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`+ Anadir experiencia laboral`)
};

const it_resume_editor_add_work = /** @type {(inputs: Resume_Editor_Add_WorkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`+ Aggiungi esperienza lavorativa`)
};

const nl_resume_editor_add_work = /** @type {(inputs: Resume_Editor_Add_WorkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`+ Werkervaring toevoegen`)
};

const pl_resume_editor_add_work = /** @type {(inputs: Resume_Editor_Add_WorkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`+ Dodaj doswiadczenie zawodowe`)
};

const fi_resume_editor_add_work = /** @type {(inputs: Resume_Editor_Add_WorkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`+ Lisää työkokemus`)
};

const da_resume_editor_add_work = /** @type {(inputs: Resume_Editor_Add_WorkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`+ Tilföj erhvervserfaring`)
};

const sv_resume_editor_add_work = /** @type {(inputs: Resume_Editor_Add_WorkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`+ Lagg till arbetslivserfarenhet`)
};

/**
* | output |
* | --- |
* | "+ Add Work Experience" |
*
* @param {Resume_Editor_Add_WorkInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const resume_editor_add_work = /** @type {((inputs?: Resume_Editor_Add_WorkInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Resume_Editor_Add_WorkInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_resume_editor_add_work(inputs)
	if (locale === "fr") return fr_resume_editor_add_work(inputs)
	if (locale === "es") return es_resume_editor_add_work(inputs)
	if (locale === "it") return it_resume_editor_add_work(inputs)
	if (locale === "nl") return nl_resume_editor_add_work(inputs)
	if (locale === "pl") return pl_resume_editor_add_work(inputs)
	if (locale === "fi") return fi_resume_editor_add_work(inputs)
	if (locale === "da") return da_resume_editor_add_work(inputs)
	if (locale === "sv") return sv_resume_editor_add_work(inputs)
	return en_resume_editor_add_work(inputs)
});